// src/features/orders/components/OrdersToolbar.tsx

/**
 * Presentation-only strip below the header. Holds static, non-data-driven
 * chrome for the Orders workspace — no props, no computed values.
 */
export function OrdersToolbar() {
  return (
    <p className="text-sm text-[var(--vania-colors-text-secondary,#a3aab8)]">
      فهرست سفارش‌های ثبت‌شده توسط مشتریان.
    </p>
  );
}
